import React from 'react';
import moment from 'moment-timezone';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate } from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';

import styled from 'styled-components';
import Tooltip, { getTooltipTarget } from 'components/Tooltip';

const Wrapper = styled.div`
  .DayPickerInput {
    width: 100%;

    input {
      width: 100%;
      height: calc(1em + 1.375rem + 2px);
      font-size: 16px;
      color: #333;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #e8e8e8;
      padding: 0.6875rem 0.6875rem;
    }
  }
`;

const Datepicker = ({
  format = 'MM/DD/YYYY',
  dataTest,
  disablePastDates,
  value,
  onChange,
  title,
  tooltipProps,
}) => {
  const id = `${title}-dayPickerInput`;

  return (
    <Wrapper data-testid={dataTest}>
      <Tooltip {...tooltipProps} />
      <DayPickerInput
        inputProps={{ id, ...getTooltipTarget(tooltipProps) }}
        value={value}
        format={format}
        formatDate={(date) => moment(date).format(format)}
        parseDate={(str) => {
          //Make sure the string in the input has the same length as the format
          if (str.length !== format.length) return undefined;
          const m = moment(str, format);
          //Make sure the moment object is valid
          if (m.isValid()) {
            return m.toDate();
          }
          return undefined;
        }}
        onDayChange={(date) => {
          onChange(date);
        }}
        dayPickerProps={{
          disabledDays: { before: disablePastDates ? new Date() : null },
        }}
        placeholder={`${moment().format(format)}`}
      />
    </Wrapper>
  );
};

Datepicker.defaultProps = {
  onChange: () => {},
  crewAutoCompleteOptions: [],
};

export default Datepicker;
